import { FC, MouseEventHandler } from 'react';

import { SearchDocument } from '@cfa/pathway-fe-shared/xp';

import { HeadingItem } from '@/utils/document-utils';
import { cn } from '@/utils/tailwind';

import { Breadcrumb } from '@/types/types';

import { CopyrightFooter } from '../common';

import TableOfContents from './TableOfContents';
import TridionTitle from './TridionTitle';

import DocumentCompleteButton from '@/routes/Layout/Header/RightHeaderContent/DocumentCompleteButton';

interface DesktopViewProps {
  lastModified?: string;
  breadcrumbs: Breadcrumb[];
  /** Custom icon content to render */
  iconContent?: React.ReactNode;
  documentContent: React.ReactNode;
  tocItems?: HeadingItem[];
  handleTocItemClick?: MouseEventHandler<HTMLAnchorElement>;
  title: string;
  tags: string[];
  isTraining: boolean;
  language: string;
  className?: string;
  /** Document type */
  type?: SearchDocument['type'];
}

/** Tridion document desktop view. */
const DesktopView: FC<DesktopViewProps> = ({
  lastModified,
  breadcrumbs,
  iconContent,
  documentContent,
  tocItems = [],
  handleTocItemClick = () => {},
  title,
  tags,
  isTraining,
  language,
  className,
  type,
}) => (
  <div
    className={cn('tridion-components bg-base-2 flex justify-start', className)}
  >
    <div>
      <div className="shadow-elevation-4 border-t-brand-navy xl:bg-base-0 relative w-full max-w-[652px] border-t-[5px]">
        <TridionTitle
          breadcrumbs={isTraining ? [] : breadcrumbs}
          iconContent={iconContent}
          tags={tags}
          title={title}
        />

        {tocItems.length ? (
          <TableOfContents
            className="block lg:hidden"
            handleClick={handleTocItemClick}
            tocItems={tocItems}
            language={language}
          />
        ) : null}
        <div
          className={cn('tridionDocument bg-base-0 lg:mt-10', {
            native: window.native.isNative,
            'lg:mt-0': type === 'GAME',
          })}
        >
          {documentContent}
        </div>
      </div>
      {isTraining && (
        <div className="max-w-[622px] px-0 pt-8 text-center">
          <DocumentCompleteButton />
        </div>
      )}

      <CopyrightFooter
        breadcrumbs={isTraining ? [] : breadcrumbs}
        lastPublishedDate={lastModified ?? ''}
        isTraining={isTraining}
      />
    </div>
    {tocItems.length ? (
      <TableOfContents
        className="hidden lg:block"
        handleClick={handleTocItemClick}
        tocItems={tocItems}
        language={language}
      />
    ) : null}
  </div>
);

export default DesktopView;
